import styled from 'styled-components/native';

import { ScaleValueProps } from 'sleepio/components/screens/SessionsScreen/utils/scaler';

export const LoadingWrapper = styled.View<ScaleValueProps>`
  height: 100%;
  width: 100%;
`;
LoadingWrapper.displayName = `LoadingWrapper`;
